import { Injectable, Pipe, PipeTransform } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { TimeUnit } from '@sb-tools/typescript/enums/time-unit.enum';

@Injectable({ providedIn: 'root' })
@Pipe({ name: 'timeUnitName' })
export class TimeUnitNamePipe implements PipeTransform {
    constructor(private translateService: TranslateService) {}

    transform(timeUnit: TimeUnit): string {
        switch (timeUnit) {
            case TimeUnit.minute:
                return this.translateService.instant('minutes');
            case TimeUnit.hour:
                return this.translateService.instant('hours');
            case TimeUnit.day:
                return this.translateService.instant('days');
            case TimeUnit.month:
                return this.translateService.instant('months');
            default:
                return '';
        }
    }
}
